import { Component, OnInit } from '@angular/core';
import {HssResponse} from '../../../services/rest-api/HssResponse';
import {HssErrorResponse} from '../../../services/rest-api/HssErrorResponse';
import {InfoApiService} from '../../../services/rest-api/info.api.service';
import {ActivatedRoute, NavigationExtras, Router} from '@angular/router';
import {toInteger} from '@ng-bootstrap/ng-bootstrap/util/util';
import {SeoService} from '../../../services/seo/seo.service';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent implements OnInit {

  allNewsData: any[] = [];
  allFaq: any[] = [];
  public deptId: number = 0;
  facultyId = 0;

  constructor(private _info: InfoApiService,
              private _actRoute: ActivatedRoute,
              private router: Router,
              private seo: SeoService) {}

  ngOnInit(): void {

    this.seo.setMeta('Frequently Asked Questions',
      'FAQ, Faculty of HSS, University of Ruhuna')

    this.deptId = this._actRoute.snapshot.params.id;

    this._actRoute.paramMap.subscribe(params => {
      // Load active news
      this.getActiveNews();
      if(this.deptId == undefined){
        this.getAllFaqByFaculty();
      } else {
        this.getAllFaqByDept(this.deptId);
      }
    });
  }

  navigatePage(current: string, param?: number) {
    if (current === 'info') {
      const navigationExtras: NavigationExtras = {
        queryParams: {
          event: JSON.stringify(param)
        }
      };
      this.router.navigate(['/info/'],navigationExtras);
    }
  }

  // Get news  data - ID 1
  getActiveNews(){
    this._info.getActiveInfo(2).subscribe (
      (response: HssResponse<any>) => {
        this.allNewsData = response.body;
      },
      (error: HssErrorResponse<any>) => {
        // Show the failed message
        const message = Array.isArray(error.message) ? error.message.join('<br/>') : error.message;
      }
    );
  }

  // Get FAQs for department
  getAllFaqByDept(deptId: number){
    this._info.getAllFaqByDept(deptId).subscribe (
      (response: HssResponse<any>) => {
        this.allFaq = response.body;
      },
      (error: HssErrorResponse<any>) => {
        // Show the failed message
        const message = Array.isArray(error.message) ? error.message.join('<br/>') : error.message;
      }
    );
  }

  // Get FAQs for faculty
  getAllFaqByFaculty(){
    this._info.getAllFaqByFaculty().subscribe (
      (response: HssResponse<any>) => {
        this.allFaq = response.body;
      },
      (error: HssErrorResponse<any>) => {
        // Show the failed message
        const message = Array.isArray(error.message) ? error.message.join('<br/>') : error.message;
      }
    );
  }
}
